
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weth",
      function () {
        return require("private-next-pages/weth.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weth"])
      });
    }
  